(function() {
    var SelectAllButton = function ($el) {
        this.$el = $el
        this.selector = this.$el.data('selector')

        this.$el.on('click', {selector: this.selector}, this.checkAll)

        return this
    }

    SelectAllButton.prototype.checkAll = function (event) {
        $(event.data.selector).not(this)
            .prop('checked', this.checked)

        return this
    }

    $('.btn-print-all').each(function () {
        new SelectAllButton($(this))
    })
})()
